import logo from './mainLogo.png';


const SuccessToast = ({dogName, email, onClose }) => {

  return (
    <div className="toast-overlay">
      <div className="toast-card" onClick={(e) => e.stopPropagation()}>
        {/* <div className="toast-icon">Logo?</div>
         */}
         <img src={logo} className="logo-notification"  alt="logo" />
        <h2>Your walk has been successfully booked for {dogName}!</h2>
        <p>
           
          <br />
          A confirmation email has been sent to <strong>{email}</strong>
        </p>
        <button onClick={onClose} className="toast-button">
          Awesome!
        </button>
      </div>
    </div>
  );
};

export default SuccessToast;